<template>
    <div v-wechat-title="title" class="padding5">
        <el-row type="flex" align="middle">
            <el-col class="align-right">
                <el-button type="primary" size="mini" @click="SyncUseDrug">同步</el-button>
                <el-button type="primary" size="mini" @click="printAllItems">打印</el-button>
                <el-button type="primary" size="mini" @click="saveItems">保存</el-button>
                 <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                        </div>
                    </el-scrollbar>

                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </el-col>
        </el-row>
        <list-view :showSequence="false" ref="supplies-list" :datalist="datalist" :tableHeight="this.screenHeight - 186" @extrabutton-click="ExtraButtonClick" :columns="userListColumn" :buttons="[]">
        </list-view>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
export default {
    name: `OrderIndex`,
    props: {},
    data() {
        return {
            title: `医嘱执行记录`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            defaultBeforeUseDrugRecord: this.$root.DefaultBeforeUseDrugRecord,
            recordconfiglist: [],
            decimalNumber: this.$root.DecimalNumber && parseInt(this.$root.DecimalNumber) || 2,
            datalist: [],
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            tableName: `api_Nursing/OrderIndex`,
            user_config_columns: [],
            user_config_columns2: [],
            configColumns: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }

        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
    },
    computed: {
        ...mapGetters([`sys_enums`, `ward_auth`, `currentUser`, `screenHeight`, `active_ward`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        columnList() {
            return [{
                type: `string`,
                prop: `___index`,
                label: `unique`,
                isKey: true
            }, {
                type: `string`,
                prop: `id`,
                label: `编号`
                // isKey:true
            }, {
                type: `datetime`,
                prop: `use_date_time`,
                label: `用药时间`,
                width: `180`,
                isListable: true,
                readonly: false
            }, {
                type: `remoteselect`,
                prop: `dic_drug`,
                label: `药品名称`,
                isListable: true,
                options: `/api/AcisSystem/Drug/Search`,
                readonly: false,
                change: (that, { row }) => {
                    let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                    req.then(data => {
                        // 不新增行
                        if (row.addrow != undefined) {
                            row.addrow = `0`
                            this.$set(row, `dic_drug_type_id`, data.drug_types && data.drug_types[0])
                            this.$set(row, `unit`, data.drug_unit)
                            this.$set(row, `dose`, data.dose)
                        } else {
                            row.addrow = `0`
                            this.$set(row, `spec`, data.spec)
                            this.$set(row, `unit`, data.drug_unit)
                            this.$set(row, `amount`, 1)
                            if (this.defaultBeforeUseDrugRecord && this.defaultBeforeUseDrugRecord != `0`) {
                                this.$set(row, `sys_record_config_id`, this.defaultBeforeUseDrugRecord)
                            }
                            this.$set(row, `dose`, data.dose)
                            this.$set(row, `total_dose`, data.dose)
                            this.$set(row, `add_drug_way`, data.add_drug_way)
                            this.$set(row, `dic_drug_type_id`, data.drug_types && data.drug_types[0])
                            this.$set(row, `batch_no`, ``)
                            this.$set(row, `use_date_time`, this.$moment(_.now()).format(`YYYY/MM/DD HH:mm`))
                            this.datalist.push({ ___index: _.now(), active: true })
                        }
                    }).catch(e => { })
                }
            },
            {
                type: `string`,
                prop: `spec`,
                label: `规格`,
                readonly: true,
                isListable: true
            }, {
                type: `select`,
                prop: `dic_drug_type_id`,
                label: `药品类型`,
                width: `120`,
                isListable: true,
                options: this[`drug/drug_type`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                readonly: true
            }, {
                type: `float`,
                prop: `amount`,
                label: `数量`,
                isListable: true,
                queryable: true,
                isCreatable: true,
                isEditable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                readonly: false,
                blur: (that, { row, index }) => {
                    let surplusdose = (row.amount * (row.dose || 1) - row.total_dose) // 支数 * 默认剂量-使用量=剩余量
                    this.$set(row, `surplus_dose`, surplusdose)
                    let remark = `残余液 ${surplusdose} 倒入水池中` // 默认备注，自己调整
                    this.$set(row, `remaining_quantity_remark`, remark)
                }
            }, {
                type: `select`,
                prop: `unit`,
                label: `单位`,
                width: `120`,
                isListable: true,
                options: _.map(this[`drug/drug_unit`], d => {
                    return {
                        value: d.label,
                        label: d.label
                    }
                }),
                readonly: true
            },
            {
                type: `string`,
                prop: `batch_no`,
                label: `批号`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                readonly: false
            }, {
                type: `float`,
                prop: `total_dose`,
                label: `用量`,
                width: `100`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                decimal_places: this.decimalNumber,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                readonly: false,
                blur: (that, { row, index }) => {
                    let surplusdose = (row.amount * (row.dose || 1) - row.total_dose) // 支数 * 默认剂量-使用量=剩余量
                    let remark = `残余液 ${surplusdose} 倒入水池中` // 默认备注，自己调整
                    this.$set(row, `surplus_dose`, surplusdose)
                    this.$set(row, `remaining_quantity_remark`, remark)
                }
            },
            {
                type: `string`,
                prop: `surplus_dose`,
                label: `剩余量`,
                isListable: true
            },
            {
                type: `string`,
                prop: `remaining_quantity_remark`,
                label: `剩余剂量及处置`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                readonly: false
            },
            {
                type: `remoteselect`,
                prop: `anes_doctor`,
                label: `麻醉医生`,
                width: `140`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                readonly: false,
                showCol: true,
                options: (that, { row }) => {
                    return q => {
                        let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                        if (this.$root.UseASACheck == `1`) {
                            works = works.map(d => {
                                return {
                                    label: d.label,
                                    value: d.value,
                                    jianpin: d.jianpin,
                                    card_no: d.card_no,
                                    worker_duty: d.worker_duty,
                                    code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                }
                            })
                        }

                        if (q && q.keyword) {
                            return works.filter(d => {
                                return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                            })
                        } else {
                            return works
                        }
                    }
                }
            },
            {
                type: `remoteselect`,
                prop: `executor_doctor`,
                label: `执行人`,
                width: `140`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                readonly: false,
                showCol: true,
                options: (that, { row }) => {
                    return q => {
                        let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                        if (this.$root.UseASACheck == `1`) {
                            works = works.map(d => {
                                return {
                                    label: d.label,
                                    value: d.value,
                                    jianpin: d.jianpin,
                                    card_no: d.card_no,
                                    worker_duty: d.worker_duty,
                                    code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                }
                            })
                        }

                        if (q && q.keyword) {
                            return works.filter(d => {
                                return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                            })
                        } else {
                            return works
                        }
                    }
                }
            },
            {
                type: `remoteselect`,
                prop: `reviewer_doctor`,
                label: `核对者`,
                width: `140`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                readonly: false,
                showCol: true,
                options: (that, { row }) => {
                    return q => {
                        let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                        if (this.$root.UseASACheck == `1`) {
                            works = works.map(d => {
                                return {
                                    label: d.label,
                                    value: d.value,
                                    jianpin: d.jianpin,
                                    card_no: d.card_no,
                                    worker_duty: d.worker_duty,
                                    code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                }
                            })
                        }

                        if (q && q.keyword) {
                            return works.filter(d => {
                                return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                            })
                        } else {
                            return works
                        }
                    }
                },
                colspan: 6,
                config: {
                    collapseTags: true
                }
            },
            {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `60`,
                isListable: true,
                fixed: `right`,
                readonly: false,
                options: (that, { row }) => {
                    if (row.dic_drug) {
                        return [
                            {
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `removeItem`,
                                permission: `default`
                            }
                        ]
                    }
                }
            }]
        },
        charge_item_options() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {}
                    })
                    resolve(data)
                })
            })
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        }

    },
    mounted() {
        this.loadItems().then(() => {
            this.loadRecordconfiglist()
        })
        // 加载配置列
        this.loadConfigColumns()
        this.configColumnDrop()
    },
    methods: {
        loadItems() {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                var that = this
                let req = this.myaxios.get(`/api/AcisSystem/BeforeSurgeryUseDrug/GetBySurgeryInfoId?surgeryInfoId=${this.surgeryId}`)
                req.then(data => {
                    this.datalist = _.map(data, (d, index) => {
                        let e = {
                            id: d.id,
                            ___index: _.now() + (index + 1) * 1000,
                            dic_drug: {
                                label: (d.drug && d.drug.name) || ``,
                                value: (d.drug && d.drug.id) || 0,
                                code: (d.drug && d.drug.code) || 0,
                                abbr: (d.drug && d.drug.abbr) || 0
                            },
                            addrow: `0`,
                            dic_drug_id: d.drug.name,
                            spec: d.drug.spec,
                            amount: d.amount,
                            batch_no: d.batch_no,
                            batchno_arr: d.batchnostr && d.batchnostr.split(`,`).map(p => {
                                return {
                                    value: p,
                                    label: p
                                }
                            }) || [],
                            dic_drug_type_id: d.dic_drug_type_id,
                            anes_doctor: d.anes_doctor,
                            executor_doctor: d.executor_doctor,
                            reviewer_doctor: d.reviewer_doctor,
                            total_dose: d.total_dose,
                            add_drug_way: d.add_drug_way,
                            unit: d.unit,
                            surplus_dose: d.surplus_dose,
                            dose: d.drug && d.drug.dose,
                            remark: d.remark,
                            remaining_quantity_remark: d.remaining_quantity_remark,
                            use_date_time: d.use_date_time,
                            executor_time: d.executor_time,
                            reviewer_time: d.reviewer_time
                        }
                        return e
                    })
                    that.datalist.push({ active: true })
                    resolve()
                }).catch(e => reject(e))
            })
        },
        loadRecordconfiglist() {
            return new Promise((resolve, reject) => {
                var that = this
                let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/Get`)
                req.then(data => {
                    let r = _.map(_.filter(data, d => {
                        return !d.is_deleted
                    }), t => {
                        return {
                            value: t.id,
                            label: t.file_name
                        }
                    })
                    that.recordconfiglist = r
                    resolve()
                }).catch(e => reject(e))
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        removeItem({ row, index }) {
            if (row.id > 0) {
                let req = this.myaxios.delete(`/api/AcisSystem/BeforeSurgeryUseDrug/Delete/${row.id}`)
                req.then(data => {
                    this.datalist.splice(index, 1)
                })
            } else {
                this.datalist.splice(index, 1)
            }
        },
        saveItems() {
            return new Promise((resolve, reject) => {
                var nonePayTypeArr = []
                var savedata = _.filter(this.datalist, d => d.dic_drug && d.dic_drug != null)
                savedata.forEach(d => {
                    if (d.dic_drug == null || !d.total_dose || !d.unit || !d.use_date_time) {
                        nonePayTypeArr.push(d)
                        this.$set(d, `class_name`, `fontred`)
                    } else {
                        this.$set(d, `class_name`, ``)
                    }
                })
                if (nonePayTypeArr.length > 0) {
                    this.$message.error(`药品、用量、单位、时间不能为空！`)
                    return
                }
                let data1 = this.getAdd(savedata)
                let data2 = this.getEdit(savedata)
                if (data1.length > 0 || data2.length > 0) {
                    let req1 = this.myaxios.post(`/api/AcisSystem/BeforeSurgeryUseDrug/Post`, data1)
                    let req2 = this.myaxios.put(`/api/AcisSystem/BeforeSurgeryUseDrug/PutMany`, data2)
                    this.myaxios
                        .all(req1, req2)
                        .then(res => {
                            this.loadItems()
                            this.$message.success(`保存成功`)
                            resolve()
                        })
                        .catch(e => reject(e))
                } else {
                    this.$message.warning(`没有可保存项`)
                    resolve()
                }
            })
        },
        getAdd(savedata) {
            var that = this
            let data1 = _.map(
                _.filter(savedata, d => !d.id),
                d => {
                    return {
                        id: d.id,
                        total_dose: d.total_dose,
                        amount: d.amount,
                        unit: d.unit,
                        sys_record_config_id: d.sys_record_config_id,
                        dic_drug_id: d.dic_drug.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        biz_surgery_info_id: that.surgeryId,
                        use_date_time: d.use_date_time,
                        executor_time: d.executor_time,
                        reviewer_time: d.reviewer_time,
                        remark: d.remark,
                        batch_no: d.batch_no,
                        anes_doctor: d.anes_doctor == `` ? null : d.anes_doctor && d.anes_doctor.value,
                        executor_doctor: d.executor_doctor == `` ? null : d.executor_doctor && d.executor_doctor.value,
                        reviewer_doctor: d.reviewer_doctor == `` ? null : d.reviewer_doctor && d.reviewer_doctor.value,
                        remaining_quantity_remark: d.remaining_quantity_remark
                    }
                }
            )
            return data1
        },
        getEdit(savedata) {
            var that = this
            let data2 = _.map(
                _.filter(savedata, d => d.id > 0),
                d => {
                    return {
                        id: d.id,
                        total_dose: d.total_dose,
                        amount: d.amount,
                        unit: d.unit,
                        sys_record_config_id: d.sys_record_config_id,
                        dic_drug_id: d.dic_drug.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        biz_surgery_info_id: that.surgeryId,
                        use_date_time: d.use_date_time,
                        executor_time: d.executor_time,
                        reviewer_time: d.reviewer_time,
                        remark: d.remark,
                        batch_no: d.batch_no,
                        anes_doctor: d.anes_doctor == `` ? null : d.anes_doctor && d.anes_doctor.value,
                        executor_doctor: d.executor_doctor == `` ? null : d.executor_doctor && d.executor_doctor.value,
                        reviewer_doctor: d.reviewer_doctor == `` ? null : d.reviewer_doctor && d.reviewer_doctor.value,
                        remaining_quantity_remark: d.remaining_quantity_remark
                    }
                }
            )
            return data2
        },
        SyncUseDrug() {
            let req = this.myaxios.get(`/api/AcisSystem/BeforeSurgeryUseDrug/SyncUseDrug?surgeryId=${this.surgeryId}`)
            req.then(data => {
                this.loadItems()
            }).catch(e => {
                console.log(e)
            })
        },
        printAllItems() {
            let docId = this.$root.DOCUMENT[`YYZX001`]
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: docId,
                            id1: this.surgeryId
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadChargeItemList(q) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/Drug/Search?keyword=${q && q.keyword}`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {
                            value: d.id,
                            label: d.name,
                            abbr: d.abbr,
                            code: d.code
                        }
                    })
                    resolve(data)
                })
            })
        },
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${this.tableName}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs.map(c => {
                    return { value: c.prop, label: c.label, isListable: c.isListable }
                }).filter(d => {
                    return d.label != `unique` && d.isListable
                })
                this.user_config_columns2 = data && _.filter(data, { enabled: true })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: this.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        }

    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadItems()
        }
    }
}
</script>
<style lang="less">
.config-column {
    width: 150px;
    overflow: hidden;
    margin: 20px 0;
}

.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/BeforeSurgeryUseDrug/OrderIndex.vue